import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

export const ManuallyPostBillRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Smart Bill Entry", "1", "", "", "/accounting/payables_bills/bills/smartbillentry"),
    RightBarMethod("Automated AP", "2", "", "", ""),
    RightBarMethod("Smart Bill Entry", "3", "", "", "/accounting/payables_bills/bills/smartbillentry"),
    RightBarMethod("Enter Utility Bill (RUBS)", "4", "", "", "/accounting/payables_bills/bills/utility-bill-details"),
    RightBarMethod("Enter Credit", "5", "", "", ""),
    RightBarMethod("Pay Bills", "6", "", "", ""),
    RightBarMethod("Tenant Payable", "7", "", "", "/accounting/payables_bills/bills/newtenantpayable"),
    RightBarMethod("New Recurring Bill", "8", "", "", "/accounting/payables_bills/recurring_invoices/newrecurringbill"),
    RightBarMethod("Manually Post Bills", "9", "", "", "/accounting/payables_bills/recurring_invoices/manually_post_bills"),
    RightBarMethod("Upload Bulk Bills", "10", "", "", "/accounting/payables_bills/bills/upload-bulk-bills"),
  ]),
]
export const property = [
  {
    key:'1',
    value:
      "GF3, Block 58, Seaview Apartments, DHA Phase 5 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi,  75500",
    label:
      "GF3, Block 58, Seaview Apartments, DHA Phase 5 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi,  75500",
    units: ["GF3, Block 58, Seaview Apartments, DHA Phase 5 - Test 3"],
  },
  {
    key:'2',

    value: "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
    label: "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
    units: [
        "9723 NE 3rd Pl",
        "9823 NE 3rd Pl",
    ]
  },
  {
    key:'3',

    value:
      "9693 Oak Tree Terrace - 9693 Oak Tree Terrace  Midwest City, OK 73130",
    label:
      "9693 Oak Tree Terrace - 9693 Oak Tree Terrace  Midwest City, OK 73130",
      units: [
        "9693 Oak Tree Terrace  Midwest City, OK 73130",
        "Midwest City, OK 73130",
        "test, Midwest City, OK 73130",
    ]
  },
];


export const tableColumns = [
    {
      title: 'Payee',
      dataIndex: 'payee',
      sorter: (a, b) => a.payee.length - b.payee.length,
      width:200
    },
    {
      title: 'GL Account',
      dataIndex: 'glaccount',
      sorter: (a, b) => a.glaccount.length - b.glaccount.length,
      width:200
    },
    {
      title: 'Property - Unit',
      dataIndex: 'propertyunit',
      width:200
  
    },
      {
      title: 'Last Billed On',
      dataIndex: 'lastbilledon',
      sorter: (a, b) => a.lastbilledon.length - b.lastbilledon.length,
      width:150
  
    },
      {
      title: 'Post Code',
      dataIndex: 'postCode',
      width:100
  
    },
      {
      title: 'Amount',
      dataIndex: 'amount',
      sorter: (a, b) => a.amount.length - b.amount.length,
    },
      {
      title: 'Repeats',
      dataIndex: 'repeats',
    },
  ];
  
 export const tableData = [
    {
      key: '1',
      payee: 'test',
      glaccount: '107: Accounts Payable',
      propertyunit: 'New York No. 1 Lake Park',
      lastbilledon: '	Feb 2023',
      postCode: '	001100',
      amount: '	10.00',
      repeats: '		Never (Must Post Manually)',
    },
    {
      key: '2',
      payee: 'test2',
      glaccount: '107: Accounts Payable',
      propertyunit: 'New York No. 2 Lake Park',
      lastbilledon: '	March 2023',
      postCode: '	001100',
      amount: '	50.00',
      repeats: '		Never (Must Post Manually)',
    },
  ];